export const PASSWORDLESS_EVENTS = {
  LOGIN_VIEWED: 'passwordless_login_viewed',
  LOGIN_ENGAGED: 'passwordless_login_engaged',
  LOGIN_COMPLETED: 'passwordless_login_completed',
} as const;

export type PasswordlessEngagedAction = 'send_code' | 'verify';
